export enum PageCreationType {
    Manual = "manual",
    Automatic = "automatic",
  }